module.exports = {

    init: function() {

        // console.log('ToggleSidebar is working...');

        initialize();

        jQuery(document).on('click', '.sidebar-toggle', function(e) {
            e.preventDefault();

            var wpadminbar = 0;
            if(typeof jQuery('#wpadminbar').outerHeight() !== 'undefined') {
                wpadminbar = jQuery('#wpadminbar').outerHeight();
            }
            
            setTimeout(() => {
                jQuery(".navigation-wrapper .sidebar-scrollable").css('height', (jQuery(window).outerHeight() - wpadminbar));
                jQuery(".navbar-wrapper").toggleClass('left-sidebar-active');
                jQuery("body").toggleClass('sidebar-toggled');
                jQuery("html").toggleClass('overflow-hidden');
            }, 100);
        });

        jQuery(document).on('click', '.right-sidebar-toggle', function(e) {
            e.preventDefault();

            var wpadminbar = 0;
            if(typeof jQuery('#wpadminbar').outerHeight() !== 'undefined') {
                wpadminbar = jQuery('#wpadminbar').outerHeight();
            }

            // for ios phones, placeholder not working on html5 date fields, use current date to avoid blank field
            var today = new Date();
            var formattedToday = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+('0' + today.getDate()).slice(-2);
            jQuery('input[type="date"][data-current-date]').val(formattedToday);
            
            setTimeout(() => {
                jQuery(".contact-detail-wrapper .sidebar-scrollable").css('height', (jQuery(window).outerHeight() - wpadminbar));
                jQuery(".navbar-wrapper").toggleClass('right-sidebar-active');
                jQuery("body").toggleClass('sidebar-toggled');
                jQuery("html").toggleClass('overflow-hidden');
            }, 100);
        });

        jQuery(document).on('click', '.overlay', function(e) {
            e.preventDefault();
            
            setTimeout(() => {
                jQuery(".navbar-wrapper").removeClass('left-sidebar-active right-sidebar-active');
                jQuery("body").removeClass('sidebar-toggled');
                jQuery("html").removeClass('overflow-hidden');
                jQuery(".sidebar-scrollable").css('height', '');
            }, 100);
        });

        // jQuery(window).resize(function () {
        jQuery(window).on('resize', function(){
            initialize();
        });

        function initialize() {
            var screenWidth = jQuery(window).width();
            var wpadminbar = 0;

            if(typeof jQuery('#wpadminbar').outerHeight() !== 'undefined') {
                wpadminbar = jQuery('#wpadminbar').outerHeight();
            }

            jQuery(".inline-block-has-children").each(function(i, elem){
                jQuery(elem).removeClass('dropdown-active');
                jQuery(elem).find('.sub-menu').hide(200, function() {
                    jQuery(this).attr('style', '');
                });
            });
            
            // jQuery("html").removeClass('overflow-hidden');
            // jQuery(".navigaion-wrtapper").removeClass('active');
            // jQuery(".navbar-wrapper").removeClass('left-sidebar-active right-sidebar-active');
            // jQuery(".navigation-wrapper .sidebar-scrollable").css('height', '');
            jQuery(".contact-detail-wrapper .sidebar-scrollable").css('height', (jQuery(window).outerHeight() - wpadminbar));
        }

    }
};